module.exports = __webpack_public_path__ + "static/reviewer_1-d6a40df0b567ebec7cf74b55e56660ed.png";